import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const IMGS = {
  tools: "https://images.unsplash.com/photo-1621605815971-fbc98d665033?crop=entropy&cs=srgb&fm=jpg&q=75&w=600",
  cutting: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=75&w=900",
  shave: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&q=75&w=700",
};

const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [80, -30]);

  return (
    <section id="chi-siamo" ref={ref} data-testid="about-section" className="relative px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-20 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.25em] text-[#0B1F3A] font-mono-alt font-medium mb-4">Il Negozio</p>
          <h2 data-testid="about-address" className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Corso Giuseppe Mazzini 25A, <span className="gold-text">Novara</span>
          </h2>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }} className="lg:col-span-7 relative h-[420px] sm:h-[520px]">
          <motion.div style={{ y: y1 }} className="absolute left-0 top-0 w-[62%] h-[75%] overflow-hidden rounded-2xl border border-[rgba(11,31,58,0.25)] shadow-2xl">
            <img src={IMGS.cutting} alt="Barbiere al lavoro" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#F7F2EC]/50 to-transparent" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-[45%] h-[55%] overflow-hidden rounded-2xl border border-[rgba(11,31,58,0.25)] shadow-2xl">
            <img src={IMGS.shave} alt="Rasatura tradizionale" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#F7F2EC]/50 to-transparent" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, rotate: -6 }}
            whileInView={{ opacity: 1, rotate: -3 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="absolute right-[38%] top-[8%] w-[26%] aspect-square overflow-hidden rounded-xl border border-[rgba(11,31,58,0.4)] shadow-xl"
          >
            <img src={IMGS.tools} alt="Strumenti del barbiere" loading="lazy" decoding="async" className="w-full h-full object-cover" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
